import React from 'react';
import { Row, Col } from 'antd';
import VideoCard from 'components/VideoCard';
import MainHitbox from './MainHitbox';
import Content from 'layout/Basic/Content';
import Sider from 'layout/Basic/Sider';
import Section from 'components/Section';

interface Props {
    videos: Video[];
}

const GalleryHitbox = ({ videos }: Props): React.JSX.Element => {
    return (
        <Row gutter={16}>
            <Content>
                <MainHitbox video={videos[0]} />
            </Content>
            <Sider>
                <Section gutter={[16, 32]}>
                    <Col xs={12} md={24}>
                        <VideoCard video={videos[1]} />
                    </Col>
                    <Col xs={12} md={24}>
                        <VideoCard video={videos[2]} />
                    </Col>
                </Section>
            </Sider>
        </Row>
    );
};

export default GalleryHitbox;
